import Page from './Page';
import AdminOnly from '../../components/AdminOnly';
import { Link } from 'react-router-dom';
import { Button } from 'components/ui/button';
import { pipedriveAppEnabled } from 'lib/pipedriveApp';

function PipedriveContainer() {
  return (
    <AdminOnly>
      {pipedriveAppEnabled() ? (
        <Page />
      ) : (
        <section className="space-y-3 p-6">
          <h1 className="text-2xl font-semibold">Pipedrive-visningen er lukket</h1>
          <p>Kunder, kontaktpersoner og salgsmuligheder administreres i CRM.</p>
          {process.env.REACT_APP_CRM_ENABLED === 'true' && (
            <Button asChild>
              <Link to="/crm">Åbn CRM</Link>
            </Button>
          )}
        </section>
      )}
    </AdminOnly>
  );
}

export default PipedriveContainer;
